// extracted by mini-css-extract-plugin
export default {"sidebarLink":"SubMenu_sidebarLink__IBdPq","sidebarLink2":"SubMenu_sidebarLink2__ZNGHq"};